/**
 * Non-blocking "a new version is live" prompt.
 *
 * Shown only when a newer build id is detected while the tab is open. Reloading
 * purges stale assets and pulls the fresh route chunks.
 */
import { useEffect } from "react";
import { toast } from "sonner";
import { onNewBuildAvailable, reloadToLatest } from "@/lib/buildVersion";

export function BuildUpdateNotice() {
  useEffect(() => {
    return onNewBuildAvailable((buildId) => {
      toast("A new version of GG Life is available", {
        id: "build-update",
        description: "Reload to get the latest pathways, fixes and content.",
        duration: Infinity,
        action: {
          label: "Reload",
          onClick: () => reloadToLatest(buildId),
        },
      });
    });
  }, []);

  return null;
}
